export default {
    key: 'hotel',
    type: 'Accommodation',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: true,
    isLoadingPassengerOffers: false,
    isRental: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    contentfulId: 'hotel',
    steps: [],
} satisfies ProductConfigAccommodation;
